import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/tailwind.css'
import { AppRouter } from './app/router/AppRouter.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'
import { QueryProvider } from '@/shared/query'
import { AuthBootstrapProvider } from './app/providers/AuthBootstrapProvider.tsx'
import { AgentCatalogProvider } from './app/providers/AgentCatalogProvider.tsx'
import { AppThreadsApiProvider } from './app/providers/AppThreadsApiProvider.tsx'
import { AppSchedulesApiProvider } from './app/providers/AppSchedulesApiProvider.tsx'
import { AppPluginApiProvider } from './app/providers/AppPluginApiProvider.tsx'
import { AppUsersApiProvider } from './app/providers/AppUsersApiProvider.tsx'
import { ChatSessionProvider } from './app/providers/ChatSessionProvider.tsx'
import { CapabilitiesProvider } from './app/providers/CapabilitiesProvider.tsx'
import { postOAuthReturnFromPopup } from '@/features/plugins/connect'

const app = (
  <ErrorBoundary>
    <QueryProvider>
      <AppUsersApiProvider>
        <AuthBootstrapProvider>
          <AgentCatalogProvider>
            <CapabilitiesProvider>
              <AppThreadsApiProvider>
                <AppSchedulesApiProvider>
                  <AppPluginApiProvider>
                    <ChatSessionProvider>
                      <AppRouter />
                    </ChatSessionProvider>
                  </AppPluginApiProvider>
                </AppSchedulesApiProvider>
              </AppThreadsApiProvider>
            </CapabilitiesProvider>
          </AgentCatalogProvider>
        </AuthBootstrapProvider>
      </AppUsersApiProvider>
    </QueryProvider>
  </ErrorBoundary>
)

// If this tab is an OAuth-return popup, relay the outcome to the opener and
// close before mounting the app — the user's chat thread lives in the opener.
if (!postOAuthReturnFromPopup()) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    import.meta.env.DEV ? app : <React.StrictMode>{app}</React.StrictMode>,
  )
}
